.field {
  margin-bottom: 0;
}

.select {
  margin-bottom: 0;
}
